import React, { useContext, useState, useRef, useEffect } from 'react';

import { 
  StyledControlBar,
  LeftPanel,
  RightPanel,
  StyledHeader,
  StyledTitle,
  StyledBookTitle,
  StyledBookAuthors, 
  UpdateModal, 
  UpdateModalBody, 
  UpdateModalFooter, 
  UpdateModalInput, 
  UpdateModalBtnWhite, 
  UpdateModalBtn
} from './control-bar.styles';

import GoBackButton from './go-back-button';
import ShowTOCSidebarButton from './show-toc-sidebar-button';
import ShowThumbnailsSidebarButton from './show-thumbnails-sidebar-button';
import ShowBookmarksSidebarButton from './show-bookmarks-sidebar-button';
import ToggleBookmarkButton from './toggle-bookmark-button';
import ToggleBookToShelfButton from './toggle-book-to-shelf-button';
import SearchButton from './search-button';
import ShowSpeechDropdownButton from './show-speech-dropdown-button';
import EditorButton from './editor-button';
import ShowSettingsDropdownButton from './show-settings-dropdown-button';
import VerticalDivider from './vertical-divider';
import { Context } from '../../store/store';
import { GET_ELIB_LIMIT, GET_ELIB_LIMIT_UPDATE_OR_CREATE } from '@graphql/editor';

const ControlBar = ({ cookie, bookId, bookTitle, bookAuthors, bookBibl, targetAudience, userId }) => {
  const [state, { efedNoAuth }] = useContext(Context);
  const [biblModal, setBiblModal] = useState(false);
  const wrapperRef = useRef();
  useOnClickOutside(wrapperRef, () => setBiblModal(false));

  return (
    <StyledControlBar>
      <LeftPanel>
        {efedNoAuth ? null : (
          <>
            <GoBackButton href={`https://new.nlrs.ru/open/${bookId}`} />
            <VerticalDivider />
          </>
        )}
        <ShowTOCSidebarButton />
        <ShowThumbnailsSidebarButton />
        {efedNoAuth ? null : <ShowBookmarksSidebarButton />}
      </LeftPanel>
      <StyledHeader>
        <StyledTitle style={{cursor: "pointer"}} title="Библиографическая запись" onClick={() => setBiblModal(true)}>
          {bookTitle.split(/<\/*br\s*\/*>/).map((element) => <StyledBookTitle>{element}</StyledBookTitle>)}
        </StyledTitle>
          {biblModal &&
            <UpdateModal>
             <UpdateModalBody ref={wrapperRef}>
              <h3>Библиографическая запись</h3>
              <textarea>{bookBibl}</textarea>
              <UpdateModalFooter>
                <UpdateModalBtnWhite onClick={() => setBiblModal(false)}>Отмена</UpdateModalBtnWhite>
              </UpdateModalFooter>
              </UpdateModalBody>
            </UpdateModal>
          }
      </StyledHeader>
      <RightPanel>
        {[8888, 12809, 120169].includes(bookId) && <ShowSpeechDropdownButton />}
        {efedNoAuth ? null : (
          <>
            <ToggleBookmarkButton />
            <ToggleBookToShelfButton />
          </>
        )}
        <SearchButton />
        <ShowSettingsDropdownButton bookId={bookId} />


        {state.isUserLoggedIn && ["48059", "42050", "175723", "40865", "66221", "13679", "89060", "65075", '12868'].includes(userId) && <EditorButton cookie={cookie} /> || state.isUserLoggedIn && ["2","4","5","6","9","10","11","12","13","14"].includes(targetAudience) && <EditorButton cookie={cookie} /> }

      </RightPanel>
    </StyledControlBar>
  );
};

function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [ref, handler]
  );
}

export default ControlBar;
